import { useEffect } from 'react';
import { useNotifier } from '@provider/notifier';
import { UploadIcon } from '@ui/kit';
import { loadExportLibrary } from '@utils/common';
import { UniversalContextMenuButton } from '../molecule.contextmenu.js';
import { makeDriveExportModal } from './modal.js';
import { useGetCloudEntriesQuery } from './query.get-cloud-entries.js';
import { jsx } from 'react/jsx-runtime';
import { useComponentEntry } from '../../../api.component-entry/query.get.js';

function LegacyDriveButton(props) {
  const notifier = useNotifier();
  const {
    data: componentEntryId
  } = useComponentEntry(props.entryKey, {
    select: entry => entry?.envelope.objectID
  });
  const {
    data: modifiedAt
  } = useComponentEntry(props.entryKey, {
    select: entry => entry?.envelope.modified ? new Date(entry.envelope.modified * 1000) : undefined
  });
  const cloudEntries = useGetCloudEntriesQuery(componentEntryId);
  const hasUploadedMostRecentEntry = (() => {
    if (!modifiedAt || !cloudEntries.data) {
      return false;
    }
    return modifiedAt <= (cloudEntries.data.googleDrive?.modifiedAt ?? new Date(0)) || modifiedAt <= (cloudEntries.data.oneDrive?.modifiedAt ?? new Date(0));
  })();
  const onClick = async () => {
    props.onClick?.();
    await notifier.modal(makeDriveExportModal({
      input: props.input,
      entryKey: props.entryKey,
      componentTitle: props.componentTitle,
      printCss: props.printCss,
      printOrientation: props.printOrientation ?? "portrait",
      format: props.format,
      onAfterExport: props.onAfterExport,
      onAfterHTMLSent: props.onAfterHTMLSent,
      onBeforeExport: props.onBeforeExport
    }));
  };
  useEffect(() => {
    const silentSSO = async () => {
      const gExport = window.gExport ?? (await loadExportLibrary());
      gExport.GoogleApi.onInitialAuthorization(() => {
        if (gExport.GoogleApi.isAuthorized()) {
          gExport.GoogleApi.getUserData().catch(() => {
            // ignore errors; they're meaningless here as we're just trying to
            // run background authz
          });
        }
      });
      gExport.MicrosoftApi.onInitialAuthorization(() => {
        if (gExport.MicrosoftApi.isAuthorized()) {
          gExport.MicrosoftApi.getUserData().catch(() => {
            // ignore errors; they're meaningless here as we're just trying to
            // run background authz
          });
        }
      });
    };
    silentSSO();
  }, []);
  return /*#__PURE__*/jsx(UniversalContextMenuButton, {
    disabled: props.disabled,
    layout: props.layout,
    state: hasUploadedMostRecentEntry ? "success" : undefined,
    as: "button",
    label: "Gem p\xE5 drev",
    onClick: onClick,
    icon: /*#__PURE__*/jsx(UploadIcon, {
      height: 20
    })
  });
}

export { LegacyDriveButton };
//# sourceMappingURL=button.js.map
